import type { CheckBox } from '@syncfusion/ej2-buttons';

export async function radiobutton(stepId: string, fieldId: string, max: number, itemId: string, value: string, hasError: boolean, enabled: boolean = true, siblings: string[], beforeSubmit: Function, afterSubmit: Function, triggerWhenChange: boolean = true, classname: string = "e-checkboxcustom", label: string = '') {

    await import('@syncfusion/ej2-base/styles/bootstrap4.css');
    await import('@syncfusion/ej2-buttons/styles/bootstrap4.css');

    await import('./loadSyncfusion');

    const { CheckBox } = await import('@syncfusion/ej2-buttons');

    const dataEle = document.getElementById('data_' + fieldId);
    const itemContainerEle = document.getElementById('container_' + fieldId + '_' + itemId);
    const inputEle = document.getElementById('input_' + fieldId + '_' + itemId);

    if (inputEle.hasAttribute("data-radiobutton")) {
        var element: any = inputEle;
        var ej2 = element.ej2_instances[0];
        ej2.disabled = !enabled || (max === 0);
        (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
        ej2.checked = value == "1";
        return;
    }

    inputEle.setAttribute('data-radiobutton', 'true');

    let dataEleVal = dataEle.getAttribute('value');

    let ddObject = new CheckBox({
        label: label,
        disabled: !enabled,
        cssClass: classname,
        checked: value == "1",
        change: (args: any) => {
            dataEleVal = dataEle.getAttribute('value');

            dataEle.setAttribute('value', ddObject.checked ? "1" : "0");

            if (!(ddObject as any).handleEvents) {
                return;
            }

            if (ddObject.checked) {
                for (let i = 0; i < siblings.length; i++) {
                    const siblingId = siblings[i];
                    const siblingEle = document.getElementById(siblingId) as any;

                    if (!siblingEle) {
                        continue;
                    }

                    const siblingEj2 = siblingEle.ej2checkbox as CheckBox;

                    if (!siblingEj2.checked) {
                        continue;
                    }

                    (siblingEj2 as any).handleEvents = false;
                    siblingEj2.click();
                    siblingEj2.checked = false;
                    siblingEj2.refresh();
                    (siblingEj2 as any).handleEvents = true;
                }
            }

            if (triggerWhenChange)
            {
                if (beforeSubmit) {
                    beforeSubmit();
                }

                ((window as any).htmx as any).trigger('#updatebutton', 'click');

                if (afterSubmit) {
                    afterSubmit();
                }
            }
        },
        created: (args: any) => {
            (inputEle.parentNode as HTMLElement).classList.toggle('e-error', hasError);
            itemContainerEle.style.display = null;
        }
    });

    ddObject.appendTo('#input_' + fieldId + '_' + itemId);

    (inputEle as any).ej2checkbox = ddObject;
    (ddObject as any).handleEvents = true;
}